// One answer per page for "may this member open it?", shared by the sidebar
// entry and the page's own check so the two can never disagree.
//
// Each page follows the capability whose role set the server enforces on the
// page's data endpoints:
//   Stats      — `GET agency/stats` answers owner and manager only, the role
//                set of `stats.perUser`. `stats.view` is held by every role in
//                the matrix, but the endpoint refuses the roles below manager,
//                so gating the page on it would open a page that cannot load.
//   Log Center — one tab per feed: `audit.view`, `meta_activity.view`,
//                `mcp_calls.view` (owner and manager). The page opens when the
//                member holds at least one.
//   Team       — `team.view` (owner, manager and read-only in the matrix).
//
// Callers pass the member's live capability list (`useCapabilities()`); when
// the profile carries none, the answer comes from the role matrix.

import { canResolve, type Capability, type EmployeeRole } from './permissions';

type Caps = string[] | null | undefined;
type Role = EmployeeRole | null | undefined;

export const STATS_PAGE_CAPABILITY: Capability = 'stats.perUser';

export const LOG_CENTER_CAPABILITIES: Capability[] = [
  'audit.view',
  'meta_activity.view',
  'mcp_calls.view',
];

export const TEAM_PAGE_CAPABILITY: Capability = 'team.view';

export function canViewTeamPage(capabilities: Caps, role: Role): boolean {
  return canResolve(capabilities, role, TEAM_PAGE_CAPABILITY);
}

export function canViewStatsPage(capabilities: Caps, role: Role): boolean {
  return canResolve(capabilities, role, STATS_PAGE_CAPABILITY);
}

export function canViewLogCenter(capabilities: Caps, role: Role): boolean {
  return LOG_CENTER_CAPABILITIES.some((cap) =>
    canResolve(capabilities, role, cap)
  );
}
